import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M50 36v-4c0-5.523-4.477-10-10-10s-10 4.477-10 10v4m10 9v4m-6.4 9h12.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C56 53.44 56 51.76 56 48.4v-2.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C51.44 36 49.76 36 46.4 36H33.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C24 40.56 24 42.24 24 45.6v2.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C28.56 58 30.24 58 33.6 58"
    />
  </svg>
);
export default SvgLock;
